import React from "react";

const InstaIframe = () => {
  return (
    <iframe
      title="insta"
      loading="lazy"
      src="https://instagram.demobw.com/showcase/"
      frameborder="0"
      width="100%"
      className="insta-iframe"
    ></iframe>
  );
};

export default InstaIframe;
